// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1L6lU","balanceDisclaimer":"posDashboard_balanceDisclaimer__1MRFa"};